import axiosClient from "./axiosClient";

const supportApi = {
  requestAccountDeletion: (params) =>
    axiosClient.post("public/delete-account-request", params),
};

export default supportApi;
